"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgExplosion(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    width: 16,
    height: 17,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M8 2.543c-1.408.001-2.092.644-2.488 1.017-.08.074-.147.138-.206.183-.111.085-.347.087-.622.089-.615.003-1.426.009-1.47.959-.033.685-.342 1.056-.658 1.435-.318.382-.643.772-.701 1.499-.118 1.45 2.676 2.454 3.45 2.012.3 1.181.31 3.278.31 3.278l1.564-2.654.816 2.386.826-2.386 1.564 2.654s.01-2.097.31-3.278c.774.441 3.568-.563 3.45-2.012-.058-.727-.383-1.117-.7-1.499-.317-.38-.626-.75-.658-1.435-.045-.95-.856-.956-1.472-.96-.274-.001-.51-.003-.62-.088a2.973 2.973 0 01-.207-.183C10.092 3.187 9.408 2.544 8 2.543zM4.992 13.669s-.676-.023-.678.555c0 .578.615.62.615.62h6.142s.615-.042.615-.62c-.002-.578-.678-.555-.678-.555H4.992z",
    fill: "#D0021B"
  }));
}

var MemoSvgExplosion = /*#__PURE__*/React.memo(SvgExplosion);
var _default = MemoSvgExplosion;
exports["default"] = _default;